import { PropsWithChildren } from "react";

import Link from "@whoppah/next/link";

import { cn } from "@/common/utils/css.utils";

type AccountLayoutMenuListItemProps = {
  path: string;
  active: boolean;
  className?: string;
  onClick?: () => void;
};

export const AccountLayoutMenuListItem = ({
  children,
  path,
  active,
  className,
  onClick,
}: PropsWithChildren<AccountLayoutMenuListItemProps>) => {
  return (
    <Link
      href={path}
      prefetch={false}
      onClick={onClick}
      aria-current={active ? "page" : undefined}
      className={cn(
        "flex cursor-pointer items-center rounded-xl border border-transparent px-4 py-2.5 font-body text-base hover:bg-flavour-50 hover:text-brand-500 xl:rounded-full xl:px-6",
        active
          ? "border-flavour-200 bg-flavour-100 text-brand-500"
          : "text-black",
        className
      )}
    >
      {children}
    </Link>
  );
};
